const deliveryConditions = {
  orderConfirmation: 'Within {time} minutes after order confirmation',
  deliveryByAppointment: 'Messenger service with appointment',
  deliveryByAgreement: 'Courier service by appointment',
  expressDelivery: 'Express delivery',
  deliveryCost: 'Delivery: {cost}',
  nextDelivery: 'Next possible delivery time',
  pickupTip: 'Your order is usually ready for pickup*',

  deliveryThreshold: 'Delivery from: {cost}',
  freeDeliveryThreshold: 'Free delivery from: {cost}',

  expressDeliveryThreshold: 'Express delivery from: {cost}',
  freeExpressDeliveryThreshold: 'Free express delivery from: {cost}',

  zipCodes: 'Delivery to zip code: {codes}',
}

export default deliveryConditions
